import React from 'react';
import { t } from 'ttag';
import classNames from 'classnames';
import { generatePath } from 'react-router-dom';

import CheckIcon from '@svg/check.svg';
import { Title } from '@ui/Title';
import { Button } from '@ui/Button';
import { memberReviewRequests } from '@urls';
import { LocalizedLink } from '@ui/LocalizedLink';

import s from './ReviewThanks.sss';

type Props = {
  nextReviewRequest?: {
    threadId: number;
  } | null,
  publishingTimeInfo: boolean,
  className?: string,
};

export const ReviewThanks: React.FC<Props> = ({
  className, publishingTimeInfo, nextReviewRequest,
}) => (
  <div className={classNames(s.root, className)}>
    <CheckIcon className={s.iconHolder} />
    <Title type="h3" className={s.title}>
      {t`Дякую за відгук!`}
    </Title>
    {publishingTimeInfo && (
      <div className={s.text}>
        {t`Ваш відгук буде опубліковано протягом`}
        {' '}
        <span className={s.boldText}>{t`14 днів.`}</span>
        {' '}
        {t`Ми повідомимо вас про це.`}
      </div>
    )}
    {nextReviewRequest && (
      <LocalizedLink
        className={s.closeButton}
        href="/"
      >
        {t`До покупок`}
      </LocalizedLink>
    )}
    <div className={s.buttons}>
      {nextReviewRequest ? (
        <Button
          href={generatePath(memberReviewRequests)}
          className={s.nextReviewRequest}
        >
          {t`Залишити наступний відгук`}
        </Button>
      ) : (
        <Button
          href="/"
          className={s.nextReviewRequest}
        >
          {t`До покупок`}
        </Button>
      )}
    </div>

  </div>
);
